<div class="content p-5">
  <p class="is-bold is-size-5 color-darkblue has-text-centered">
    {{ data.isConnectOrigin ? 'Hinweis' : 'Weitere Informationen erforderlich' }}
  </p>

  <div *ngIf="selectedProperty.isTeilunObtainableOnSite" class="columns mb-0">
    <div class="column line-height-is-2 pb-0">
      <p>Die Beschaffung der vollständigen Teilungserklärung ist in dieser Region nur durch einen vor Ort Besuch der
        zuständigen Behörde möglich. Die Bearbeitungsgebühr (Kopierkosten fallen nicht an) für den vor Ort Service
        beträgt:</p>

      <div class="title is-4 has-text-centered is-bold color-darkblue mb-3">
        {{ data.teilungPrice }} €
      </div>
    </div>
  </div>

  <ng-container *ngIf="!data.isConnectOrigin">
    <p class="is-bold">Für die Beschaffung der Teilungserklärung sind weitere Informationen erforderlich.</p>

    <p class="is-bold is-size-6 mt-4 mb-0">Grundbuchblatt-Nr.</p>

    <app-folio-number [property]="selectedProperty" [displayAdditionalCostInformation]="false"></app-folio-number>
  </ng-container>

  <ng-container *ngIf="ProductUtils.shouldOpenProductValueDialog([teilunProduct]) else defaultButtons">
    <hr>
    <app-product-value-form [products]="[teilunProduct]" [property]="selectedProperty" [hasPadding]="false"
                            (cancelModalEvent)="cancelModal()"
                            [displayHeader]="false" [displayDocName]="false"
                            (confirmModalEvent)="submitModal()"></app-product-value-form>
  </ng-container>

  <ng-template #defaultButtons>
    <div class="columns">
      <div class="column is-one-third">
        <a class="button back-button has-round-border" (click)="cancelModal()">
          <div class="columns is-align-items-center is-justify-content-center">
            <div class="column is-bold">
              <p class="mb-0">Abbrechen</p>
            </div>
          </div>
        </a>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third">
        <a class="button buy-button has-round-border" (click)="submitModal()">
          <div class="columns is-align-items-center is-justify-content-center">
            <div class="column is-bold">
              <p class="mb-0">Bestätigen</p>
            </div>
          </div>
        </a>
      </div>
    </div>
  </ng-template>

</div>
